import { Component, input, effect } from '@angular/core';
import { ResponsiveVisibility } from '../../responsive-visibility';
import { IPDFViewerApplication } from '../../options/pdf-viewer-application';
import { PDFNotificationService } from '../../pdf-notification-service';

@Component({
    selector: 'pdf-move-down',
    templateUrl: './pdf-move-down.component.html',
    styleUrls: ['./pdf-move-down.component.css'],
    standalone: false
})
export class PdfMoveDownComponent {
  public showMoveDownButton = input<ResponsiveVisibility>(true);

  // #2818 modified by ngx-extended-pdf-viewer
  public disable = input<boolean>(false);
  // #2818 end of modification by ngx-extended-pdf-viewer

  private PDFViewerApplication: IPDFViewerApplication | undefined;

  constructor(notificationService: PDFNotificationService) {
    effect(() => {
      this.PDFViewerApplication = notificationService.onPDFJSInitSignal();
    });
  }

  public movePageDown = () => {
    if (this.PDFViewerApplication) {
      const currentPage = this.PDFViewerApplication.page;
      // #3216 eventBus may be undefined during destroy/recreate transitions of the PDFViewerApplication singleton.
      this.PDFViewerApplication.eventBus?.dispatch('movePageDown', {
        source: { pageNumber: currentPage }
      });
    }
  };
}
